import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  clientData: null,
  addBtnLoading: false,
  clientBtnLoading: false,
  deleteBtnLoading: false,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CLIENTS:
      return updateObject(state, action.payload);
    case actionTypes.CLIENT_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
